import { render, staticRenderFns } from "./ImpersonateRevokeDialog.vue?vue&type=template&id=ccd20a98&"
import script from "./ImpersonateRevokeDialog.vue?vue&type=script&lang=js&"
export * from "./ImpersonateRevokeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonateRevokeDialog.vue?vue&type=style&index=0&id=ccd20a98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports